import { SupportModal, NavbarDefault } from 'app/components';
import AdminUsers from './AdminUsers';

const UsersRouter = () => {
  return (
    <div>
      <div className="grid--container full--height columns">
        <div className="content">
          <AdminUsers />
        </div>
      </div>
      <NavbarDefault />
      <SupportModal />
    </div>
  );
};

export default UsersRouter;
